/**
 * Shared utilities for JSON array fields stored as strings in the database.
 * @package @app/validators
 */

/**
 * Parse a JSON-string DB field into a string array. Coerces every element via
 * `String()` so downstream string ops (e.g. `.toLowerCase()` in match scoring)
 * are safe even if the DB JSON contains non-string values (legacy seed data,
 * external imports, etc.).
 */
export function parseJsonArray(value: string | null): string[] {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}

/**
 * Parse a JSON-string DB field into an array of objects (or any non-string
 * shape). No runtime coercion — caller is responsible for validating element
 * shape if it matters. Use {@link parseJsonArray} for string arrays.
 */
export function parseJsonObjectArray<T>(value: string | null): T[] {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? (parsed as T[]) : [];
  } catch {
    return [];
  }
}
